/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authorized_Apps_None_HintInputs */



/**
* | output |
* | --- |
* | "Apps you sign in to with Archon will appear here." |
*
* @param {Authorized_Apps_None_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_none_hint = /** @type {((inputs?: Authorized_Apps_None_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_None_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les applications auxquelles vous vous connectez avec Archon apparaîtront ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las aplicaciones en las que inicia sesión con Archon aparecerán aquí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os aplicativos nos quais você faz login com Archon aparecerão aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le applicazioni a cui accede con Archon appariranno qui.")
	return /** @type {LocalizedString} */ ("Apps you sign in to with Archon will appear here.")
});